import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button, Form, Badge, Card, Table, Spinner } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import Foto from "../Components/Foto";

const fotoCache = new Map();
const usuario = localStorage.getItem("chapa");

// --- Subcomponente para o Card ---
const ComunicadoCard = ({ item, onClick }) => {
    const [foto, setFoto] = useState(null);

    useEffect(() => {
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `${item.chapa}_${hoje}`;

        if (fotoCache.has(chave)) {
            setFoto(fotoCache.get(chave));
        } else {
            api.get(`/usuario/foto/${item.chapa}`)
                .then(res => {
                    fotoCache.set(chave, res.data.foto);
                    setFoto(res.data.foto);
                })
                .catch(() => console.log("Erro ao buscar foto"));
        }
    }, [item.chapa]);


    return (
        <Card className="shadow-sm h-100 mb-3" onClick={() => onClick(item, foto)} style={{ cursor: 'pointer', borderLeft: '5px solid #007bff' }}>
            <div className="d-flex p-3 align-items-center">
                <img
                    src={foto ? `data:image/jpeg;base64,${foto}` : 'https://via.placeholder.com/60'}
                    alt="Foto"
                    className="rounded-circle me-3"
                    style={{ width: '60px', height: '60px', objectFit: 'cover', border: '2px solid #eee' }}
                />
                <div style={{ flex: 1 }}>
                    <div className="d-flex justify-content-between align-items-start">
                        <Badge bg="primary" className="mb-1">{item.tipo}</Badge>
                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>{new Date(item.hora).toLocaleDateString()}</small>
                    </div>
                    <div className="fw-bold text-uppercase" style={{ fontSize: '0.85rem' }}>{item.nome}</div>
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        Matrícula: {item.chapa} <br />
                        <strong>Loja: {item.filial} ➔ <span className="text-danger">{item.lojades}</span></strong>
                    </div>
                </div>
            </div>
        </Card>
    );
};

// --- Componente Principal ---
function AprovacaoComunicado() {
    const navigate = useNavigate(); // Hook para navegação
    const [comunicados, setComunicados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [showAvaliar, setShowAvaliar] = useState(false);
    const [showLog, setShowLog] = useState(false);

    const [selected, setSelected] = useState(null);
    const [fotoSelected, setFotoSelected] = useState(null);
    const [logs, setLogs] = useState([]);
    const [motivo, setMotivo] = useState("");
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const isMobile = window.innerWidth < 768;
    const permiteDiretor = localStorage.getItem("diretor");
    const permiteRegional = localStorage.getItem("permiteRegional");
    // --- Verificação de Permissão ---
    useEffect(() => {
        const permiteRegional = localStorage.getItem("permiteRegional");
        if (permiteRegional !== "S") {
            alert("SEM PERMISSÃO AO ACESSO AO MÓDULO");
            navigate("/arbor/home");
        } else {
            loadComunicados(); // Só carrega os dados se tiver permissão
        }
    }, [navigate]);

    const loadComunicados = async () => {
        setLoading(true);

        // 1. Definimos a variável de seleção baseada nas suas regras
        let selecao = 0; // Valor padrão caso nenhuma condição seja atendida

        if (permiteDiretor === "S") {
            selecao = 4;
        } else if (permiteRegional === "S") {
            selecao = 1;
        }

        try {
            // 2. Usamos Template Literals (a crase ` `) para inserir a variável na URL
            // Note que corrigi a sintaxe do endpoint para usar a variável dinâmica
            const response = await api.get(`/usuario/comunicacao/${selecao}`);
            setComunicados(response.data);
        } catch (err) {
            console.error("Erro ao carregar comunicados:", err);
        } finally {
            setLoading(false);
        }
    };

    const getFotoUsuario = (usuario) => {
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `log_${usuario}_${hoje}`;
        const foto = fotoCache.get(chave);

        if (!foto) {
            api.get(`/usuario/foto/${usuario}`)
                .then(res => {
                    fotoCache.set(chave, res.data.foto);
                    setLogs(prev => [...prev]); // força refresh leve
                })
                .catch(() => { });
        }

        return foto;
    };

    const handleOpenDetails = (item, foto) => {
        setSelected(item);
        setFotoSelected(foto);
        setShowDetails(true);
    };

    const fetchLogs = async (codigo) => {
        setLoading(true);
        try {
            const response = await api.get(`/usuario/comunicacao/log/${codigo}`);
            setLogs(response.data);
            setShowLog(true);
        } catch (err) {
            alert("Erro ao buscar logs");
        } finally {
            setLoading(false);
        }
    };

    const handleAction = (statusAcao) => {
        setLoading(true);

        // Lógica de definição do status baseada nas suas regras:
        // status 1 + N = 12 | status 1 + A = 2
        // status 4 + N = 15 | status 4 + A = 5
        let statusFinal = 0;
        if (selected.status === 1) {
            statusFinal = statusAcao === 'N' ? 12 : 2;
        } else if (selected.status === 4) {
            statusFinal = statusAcao === 'N' ? 15 : 5;
        }

        const payload = {
            codigo: selected.cod_operacao,
            status: statusFinal, // Enviando o número calculado
            usuario,
            operacao: String(selected.tipooperacao),
            observacao: motivo,
            autorizado: "1"
        };

        api.post('/usuario/comunicacao', payload)
            .then(() => {
                setShowAvaliar(false);
                setShowDetails(false);
                setMotivo("");
                loadComunicados();
            })
            .catch(err => alert("Erro: " + err.message))
            .finally(() => setLoading(false));
    };

    const formatMoeda = (valor) => valor ? valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';

    return (
        <div>
            <Menu modulo="ARBOR" />

            <div className="container mt-4 mb-5">
                <h4 className="mb-4 text-primary border-bottom pb-2">Pendências de RH</h4>
                <div className="row">
                    {comunicados.map(item => (
                        <div className="col-lg-4 col-md-6" key={item.cod_operacao}>
                            <ComunicadoCard item={item} onClick={handleOpenDetails} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal de Detalhes */}
            <Modal
                show={showDetails}
                onHide={() => setShowDetails(false)}
                size="lg"
                centered
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    overflow: 'hidden'
                }}>
                    <Modal.Header closeButton className="bg-light" style={{ flexShrink: 0 }}>
                        <Modal.Title>Avaliação de Comunicado</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{
                        overflowY: 'auto',
                        flex: '1 1 auto',
                        padding: '15px',
                        WebkitOverflowScrolling: 'touch'
                    }}>
                        {selected && (
                            <div className="row">
                                <div className="col-md-4 text-center border-end">
                                    <img
                                        src={fotoSelected ? `data:image/jpeg;base64,${fotoSelected}` : 'https://via.placeholder.com/150'}
                                        className="img-fluid rounded shadow-sm mb-3" alt="User"
                                        style={{ cursor: 'pointer', transition: '0.3s' }}
                                        onClick={() =>
                                            setFotoSelecionada({
                                                foto: fotoSelected
                                                    ? `data:image/jpeg;base64,${fotoSelected}`
                                                    : null,
                                                nome: selected?.nome,
                                                loja: "Loja: " + selected?.filial,
                                            })
                                        }
                                    />
                                    <h6 className="mb-1">{selected.nome}</h6>
                                    <p className="text-muted small">Solicitado em: {new Date(selected.hora).toLocaleString()}</p>
                                    <Button variant="outline-secondary" size="sm" className="w-100 mt-2" onClick={() => fetchLogs(selected.cod_operacao)}>
                                        📜 VER LOGS
                                    </Button>
                                </div>
                                <div className="col-md-8">
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Loja Atual</label>
                                            <div className="fw-bold">{selected.filial}</div>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Loja Destino</label>
                                            <div className="fw-bold text-danger">{selected.lojades}</div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Setor Atual</label>
                                            <div className="fw-bold">{selected.setor}</div>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Novo Setor</label>
                                            <div className="fw-bold text-danger">{selected.descsetornovo || '--'}</div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Função Atual</label>
                                            <div className="fw-bold">{selected.funcao}</div>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Nova Função</label>
                                            <div className="fw-bold text-danger">{selected.descfuncnova || '--'}</div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Salário Atual</label>
                                            <div className="fw-bold">{formatMoeda(selected.salario)}</div>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Novo Salário</label>
                                            <div className="fw-bold text-danger">{formatMoeda(selected.salarionovo)}</div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Horário Atual</label>
                                            <div className="small" style={{ lineHeight: '1.2' }}>{selected.deschorario}</div>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small d-block">Novo Horário</label>
                                            <div className="small text-danger fw-bold" style={{ lineHeight: '1.2' }}>{selected.deschorarionovo || '--'}</div>
                                        </div>
                                    </div>
                                    <div className="mt-2 p-2 bg-light border rounded">
                                        <label className="text-muted small">Data Efetiva da Mudança:</label>
                                        <div className="fw-bold text-danger">{new Date(selected.dataefetivo).toLocaleDateString()}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="bg-light border-top" style={{ flexShrink: 0, padding: '10px' }}>
                        <Button variant="secondary" size="sm" onClick={() => setShowDetails(false)}>
                            Fechar
                        </Button>
                        <Button variant="success" size="sm" className="px-4 fw-bold" onClick={() => setShowAvaliar(true)}>
                            AVALIAR OPERAÇÃO
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
            {/* Modal de LOGS */}
            <Modal
                show={showLog}
                onHide={() => setShowLog(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>Histórico de Operações</Modal.Title>
                </Modal.Header>

                <Modal.Body
                    style={{
                        maxHeight: '65vh',
                        overflowY: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        padding: isMobile ? '10px' : '16px'
                    }}
                >
                    {/* ===== DESKTOP → TABELA ===== */}
                    {!isMobile && (
                        <Table striped hover responsive size="sm">
                            <thead className="table-dark">
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Usuário</th>
                                    <th>Status</th>
                                    <th>Autorização</th>
                                    <th>Obs</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '0.85rem' }}>
                                {logs.map((l, index) => {
                                    const fotoUser = getFotoUsuario(l.usuario);

                                    return (
                                        <tr key={index}>
                                            <td>{new Date(l.hora).toLocaleString()}</td>

                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <img
                                                        src={
                                                            fotoUser
                                                                ? `data:image/jpeg;base64,${fotoUser}`
                                                                : 'https://via.placeholder.com/40'
                                                        }
                                                        alt="User"
                                                        className="rounded-circle"
                                                        style={{
                                                            width: 32,
                                                            height: 32,
                                                            objectFit: 'cover',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() =>
                                                            setFotoSelecionada({
                                                                foto: fotoUser
                                                                    ? `data:image/jpeg;base64,${fotoUser}`
                                                                    : null,
                                                                nome: l.nome,
                                                                loja: '',
                                                            })
                                                        }
                                                    />

                                                    <div>
                                                        {l.nome}
                                                        <br />
                                                        <small className="text-muted">
                                                            {l.usuario}
                                                        </small>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <Badge bg="info">{l.descstatus}</Badge>
                                            </td>
                                            <td>{l.autorizado}</td>
                                            <td>{l.observacaolog || '-'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}

                    {/* ===== MOBILE → CARDS ===== */}
                    {isMobile && (
                        <div>
                            {logs.map((l, index) => {
                                const fotoUser = getFotoUsuario(l.usuario);

                                return (
                                    <Card key={index} className="mb-2 shadow-sm border-0">
                                        <Card.Body style={{ padding: '10px' }}>
                                            <div className="d-flex align-items-start gap-2">

                                                {/* FOTO */}
                                                <img
                                                    src={
                                                        fotoUser
                                                            ? `data:image/jpeg;base64,${fotoUser}`
                                                            : 'https://via.placeholder.com/50'
                                                    }
                                                    alt="User"
                                                    className="rounded-circle"
                                                    style={{
                                                        width: 48,
                                                        height: 48,
                                                        objectFit: 'cover',
                                                        border: '2px solid #eee',
                                                        cursor: 'pointer',
                                                        flexShrink: 0
                                                    }}
                                                    onClick={() =>
                                                        setFotoSelecionada({
                                                            foto: fotoUser
                                                                ? `data:image/jpeg;base64,${fotoUser}`
                                                                : null,
                                                            nome: l.nome,
                                                            loja: '',
                                                        })
                                                    }
                                                />

                                                {/* CONTEÚDO */}
                                                <div style={{ flex: 1, fontSize: '0.8rem' }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <Badge bg="info">{l.descstatus}</Badge>
                                                        <small className="text-muted">
                                                            {new Date(l.hora).toLocaleString()}
                                                        </small>
                                                    </div>

                                                    <div className="fw-bold">{l.nome}</div>
                                                    <div className="text-muted mb-2">{l.usuario}</div>

                                                    <div><strong>Autorização:</strong> {l.autorizado}</div>
                                                    <div>
                                                        <strong>Obs:</strong>{" "}
                                                        {l.observacaolog || '-'}
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Modal de Decisão */}
            <Modal show={showAvaliar} onHide={() => setShowAvaliar(false)} centered>
                <Modal.Header closeButton className="bg-warning text-dark">
                    <Modal.Title>Concluir Avaliação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="fw-bold">Observações / Motivo:</Form.Label>
                        <Form.Control as="textarea" rows={3} value={motivo} onChange={e => setMotivo(e.target.value)} autoFocus />
                        <Form.Text className="text-muted">Campo obrigatório para prosseguir.</Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button variant="danger" className="px-4" onClick={() => handleAction('N')} disabled={!motivo || loading}>NEGAR</Button>
                    <Button variant="success" className="px-4" onClick={() => handleAction('A')} disabled={!motivo || loading}>APROVAR</Button>
                </Modal.Footer>
            </Modal>

            <Footer />
            {/* Modal de Foto em Tela Inteira - Realmente Grande */}
            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.loja}
                info02=""
            />

            {/* Modal de Loading Global */}
            <Modal
                show={loading}
                backdrop="static" // Impede fechar ao clicar fora
                keyboard={false}  // Impede fechar com ESC
                centered
                size="sm"
                contentClassName="bg-transparent border-0" // Deixa o fundo invisível para destacar o Spinner
            >
                <Modal.Body className="text-center">
                    <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
                    <div className="text-light mt-2 fw-bold">Processando...</div>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default AprovacaoComunicado;